module.exports = __webpack_public_path__ + "500ffe2828f3f4ef734c269650d73917.svg";